import ChallengeBanner from '@base/features/ladder/components/challenges/challengeBanner/challengeBanner';
// import Search from '@ui-kit/components/search'
import styles from './forumPage.module.scss';
import { Navigation, ForumRoutes } from '@base/features/forum/components';
import TournamentBanner from '@base/features/tournaments/components/tournamentBanner';
import AdsBanner from '@base/features/advertisement/components/adsBanner';

function ForumPage() {
  return (
    <div className={styles.forum}>
      <div className={styles.tournamentBanner}>
        <div style={{ marginRight: '1rem' }}>
          <ChallengeBanner />
        </div>
        <TournamentBanner />
      </div>
      <div className={styles.adsBanner}>
        <AdsBanner />
      </div>
      <div className={styles.menu}>
        <Navigation />
      </div>
      <div className={styles.main}>
        <ForumRoutes />
      </div>
      {/* <div className={styles.search}>
        <Search />
      </div> */}
    </div>
  );
}

export default ForumPage;
